{
    "en": {
        "model": "Items",
        "model_category": "Category",
        "asset_tag": "Asset Tag",
        "serial_number": "Serial number",
        "u_service_value_1": "Value",
        "portalURL": "Portal",
        "cat_item": "Item",
        "opened_by": "Opened by",
        "number": "Number",
        "u_requesttitle": "Request Title",
        "due_date": "Due Date",
        "requested_for": "Requested for",
        "state": "State",
        "opened_at": "Opened at",
        "resolved_at": "Resolved at",
        "closed_at": "Closed at",
        "sys_created_on": "System Created On",
        "approval_set": "Approval Set",
        "description": "Description",
        "short_description": "Short description",
        "actions": "Actions"
    },
    "de": {
        "model": "Artikel",
        "model_category": "Kategorie",
        "asset_tag": "Asset Tag",
        "serial_number": "Seriennummer",
        "u_service_value_1": "Wert",
        "portalURL": "Portal",
        "cat_item": "Artikel",
        "opened_by": "Geöffnet von",
        "number": "Nummer",
        "u_requesttitle": "Bestelltext",
        "due_date": "Fälligkeitsdatum",
        "requested_for": "Angefordert für",
        "state": "Status",
        "opened_at": "Geöffnet",
        "resolved_at": "Gelöst am",
        "closed_at": "Geschlossen am",
        "sys_created_on": "System erstellt am",
        "approval_set": "Genehmigungssatz",
        "description": "Beschreibung",
        "short_description": "Kurzbeschreibung",
        "actions": "Aktionen"
    },
    "sv": {
        "model": "Objekt",
        "model_category": "Kategori",
        "asset_tag": "Tagg",
        "serial_number": "Serienummer",
        "u_service_value_1": "Värde",
        "portalURL": "Portal",
        "cat_item": "Objekt",
        "opened_by": "Beställd av",
        "number": "Nummer",
        "u_requesttitle": "Beställningstitel",
        "due_date": "Förfallodatum",
        "requested_for": "Beställd till",
        "state": "Status",
        "opened_at": "Beställdes",
        "resolved_at": "Löst vid",
        "closed_at": "Stängd vid",
        "sys_created_on": "Skapades",
        "approval_set": "Godkännande",
        "description": "Beskrivning",
        "short_description": "Kort beskrivning",
        "actions": "Åtgärder"
    },
    "ro": {
        "model": "Obiect",
        "model_category": "Categorie",
        "asset_tag": "Etichetă",
        "serial_number": "Număr de serie",
        "u_service_value_1": "Valoare",
        "portalURL": "Portal",
        "cat_item": "Element",
        "opened_by": "Comandat de",
        "number": "Număr",
        "u_requesttitle": "Titlul comenzii",
        "due_date": "Data scadentă",
        "requested_for": "Deschis pentru",
        "state": "Stare",
        "opened_at": "Deschis la",
        "resolved_at": "Rezolvat la",
        "closed_at": "Închis la",
        "sys_created_on": "Creat la",
        "approval_set": "Aprobare",
        "description": "Descriere",
        "short_description": "Descriere scurtă",
        "actions": "Acțiuni"
    },
    "pl": {
        "model": "Przedmioty",
        "model_category": "Kategoria",
        "asset_tag": "Etykieta zasobu",
        "serial_number": "Numer seryjny",
        "u_service_value_1": "Wartość",
        "portalURL": "Portal",
        "cat_item": "Przedmiot",
        "opened_by": "Otwarte przez",
        "number": "Numer",
        "u_requesttitle": "Tytuł żądania",
        "due_date": "Termin",
        "requested_for": "Żądane dla",
        "state": "Stan",
        "opened_at": "Otwarte o",
        "resolved_at": "Rozwiązane o",
        "closed_at": "Zamknięte o",
        "sys_created_on": "Utworzono w systemie",
        "approval_set": "Zestaw zatwierdzeń",
        "description": "Opis",
        "short_description": "Krótki opis",
        "actions": "Działania"
    },
    "it": {
        "model": "Articoli",
        "model_category": "Categoria",
        "asset_tag": "Tag del bene",
        "serial_number": "Numero di serie",
        "u_service_value_1": "Valore",
        "portalURL": "Portal",
        "cat_item": "Articolo",
        "opened_by": "Aperto da",
        "number": "Numero",
        "u_requesttitle": "Titolo della richiesta",
        "due_date": "Data di scadenza",
        "requested_for": "Richiesto per",
        "state": "Stato",
        "opened_at": "Aperto il",
        "resolved_at": "Risolto il",
        "closed_at": "Chiuso il",
        "sys_created_on": "Creato nel sistema il",
        "approval_set": "Set di approvazione",
        "description": "Descrizione",
        "short_description": "Breve descrizione",
        "actions": "Azioni"
    },
    "nl": {
        "model": "Items",
        "model_category": "Categorie",
        "asset_tag": "Assetlabel",
        "serial_number": "Serienummer",
        "u_service_value_1": "Waarde",
        "portalURL": "Portal",
        "cat_item": "Item",
        "opened_by": "Geopend door",
        "number": "Nummer",
        "u_requesttitle": "Verzoektitel",
        "due_date": "Vervaldatum",
        "requested_for": "Aangevraagd voor",
        "state": "Status",
        "opened_at": "Geopend op",
        "resolved_at": "Opgelost op",
        "closed_at": "Gesloten op",
        "sys_created_on": "Systeem aangemaakt op",
        "approval_set": "Goedkeuringsset",
        "description": "Beschrijving",
        "short_description": "Korte beschrijving",
        "actions": "Acties"
    },
    "hu": {
        "model": "Elemek",
        "model_category": "Kategória",
        "asset_tag": "Eszközcímke",
        "serial_number": "Sorozatszám",
        "u_service_value_1": "Érték",
        "portalURL": "Portal",
        "cat_item": "Elem",
        "opened_by": "Megnyitotta",
        "number": "Szám",
        "u_requesttitle": "Kérelem címe",
        "due_date": "Határidő",
        "requested_for": "Kért személy",
        "state": "Állapot",
        "opened_at": "Megnyitva",
        "resolved_at": "Megoldva",
        "closed_at": "Lezárva",
        "sys_created_on": "Rendszer által létrehozva",
        "approval_set": "Jóváhagyási készlet",
        "description": "Leírás",
        "short_description": "Rövid leírás",
        "actions": "Műveletek"
    },
    "cz": {
        "model": "Položky",
        "model_category": "Kategorie",
        "asset_tag": "Štítek majetku",
        "serial_number": "Sériové číslo",
        "u_service_value_1": "Hodnota",
        "portalURL": "Portal",
        "cat_item": "Položka",
        "opened_by": "Otevřeno kým",
        "number": "Číslo",
        "u_requesttitle": "Název žádosti",
        "due_date": "Datum splatnosti",
        "requested_for": "Požadováno pro",
        "state": "Stav",
        "opened_at": "Otevřeno dne",
        "resolved_at": "Vyřešeno dne",
        "closed_at": "Uzavřeno dne",
        "sys_created_on": "Systém vytvořen dne",
        "approval_set": "Sada schválení",
        "description": "Popis",
        "short_description": "Krátký popis",
        "actions": "Akce"
    }
}
